export default "__VITE_ASSET__fac30f11__"